/* import __COLOCATED_TEMPLATE__ from './fourthline.hbs'; */
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import { Spinner } from '@repo/design-system-kit';
import { Fourthline, FourthlineWebsocket } from '@repo/kyc';
import window from 'ember-window-mock';
import { reads } from 'macro-decorators';

import styles from './fourthline.module.css';

export default class FourthlineComponent extends Component {
  styles = styles;

  spinner = Spinner;
  fourthline = Fourthline;
  fourthlineWebsocket = FourthlineWebsocket;

  @service currentUser;
  @service deviceManager;
  @service session;
  @service store;
  @service segment;

  @reads('session.data.authenticated.websocket_token') websocketToken;

  get currentUserId() {
    return this.currentUser.user?.id;
  }

  get hasSpinner() {
    return this.args.regenerateLinkTask.isRunning;
  }

  get view() {
    if (this.args.isLoading) {
      return 'loading';
    } else if (this.args.kyc?.reason || this.kycNetworkError) {
      return 'error';
    } else if (this.args.kyc?.providerStatus === 'process_finished') {
      return 'finished';
    } else {
      return 'pending';
    }
  }

  /**
   * This getter builds the final redirection url
   * the provided @kyc.redirectUrl should look like:
   * https://{kyc_url}?code=XXX&redirect={qes_url?code=XXX}
   * this adds a nested "redirect" queryParam like so
   * https://{kyc_url}?code=XXX&redirect={qes_url?code=XXX&redirect={currentURL}}
   * and a first level redirect queryParam if not present in the provided @kyc.redirectUrl
   */
  get redirectUrl() {
    let url = new URL(this.args.kyc.redirectUrl);

    if (this.deviceManager.isMobile) {
      let redirection = url.searchParams.get('redirect');

      url.searchParams.set(
        'redirect',
        redirection ? redirection + `&redirect=${window.location.href}` : window.location.href
      );
    }

    return url.toString();
  }

  @action
  onInsertFourthlineFlow() {
    let screen_type = this.args.kyc.providerStatus === 'kyc_required' ? 'KYC' : 'QES';

    this.segment.track('onboarding_partner_fourthline_verification_screen_loaded', {
      screen_type,
    });
  }

  @action
  onInsertFourthlineError() {
    this.segment.track('onboarding_partner_fourthline_error_screen_loaded');
  }

  processFinished = kyc => {
    this.store.pushPayload('kyc', kyc);

    if (kyc.data.attributes.providerStatus === 'process_finished') {
      this.args.completeTask();
    }
  };

  updateKycModel = kyc => {
    let { redirect_url, provider_status, is_qes_required, reason } = kyc.data.attributes;

    this.args.kyc.setProperties({
      redirectUrl: redirect_url,
      providerStatus: provider_status,
      isQesRequired: is_qes_required,
      reason,
    });

    this.store.pushPayload('kyc', kyc);
  };
}
